import React from "react";
import FormGroup from "../FormGroup/FormGroup";
import moment from "moment";
import DatePicker from "assets/scripts/components/presentational/DatePicker/DatePicker";
function toDateString(value, format = "YYYY-MM-DD") {
    if (value == null || value === "") {
        return null;
    }
    return moment(value).format(format);
}
const DatePickerFormGroup = ({ minDate, maxDate, isDayDisabled, ...otherProps }) => (<FormGroup {...otherProps}>
		{(controlState) => (<DatePicker minDate={toDateString(minDate) || undefined} maxDate={toDateString(maxDate) || undefined} isDayDisabled={isDayDisabled} format={"MM/DD/YYYY"} computableFormat="YYYY-MM-DD" parsingFormat={["YYYY-MM-DD", "M/D/YYYY", "MMDDYYYY"]} inputProps={controlState.attrs} date={toDateString(controlState.value, "MM/DD/YYYY") || undefined} onChange={it => controlState.onChange(it || "")} closeOnSelect/>)}
	</FormGroup>);
export default DatePickerFormGroup;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/DatePickerFormGroup/DatePickerFormGroup.tsx